import type { MarketplaceOrderDeliverable } from '@foodfluence/shared';
import { deliverableIsCarousel, deliverableLabel, deliverableRequiresPublishedPost } from '@foodfluence/shared';
import { marketplaceOrderRequirementUploadSubtitle } from './marketplaceOrderUploadCopy';

export type MarketplaceUploadSectionSingle = {
  kind: 'single';
  sectionId: string;    // UI state key e.g. 'lc_pkg_1_ugcShortForm::0'
  requirementId: string; // base deliverable key e.g. 'lc_pkg_1_ugcShortForm'
  slotKey: string;       // API slotId: same as requirementId for count=1, '${requirementId}::${i}' for count>1
  slotIndex: number;
  title: string;
  subtitle: string;
};

export type MarketplaceUploadSectionPostLink = {
  kind: 'postLink';
  sectionId: string;
  requirementId: string;
  slotKey: string;
  title: string;
  subtitle: string;
};

export type MarketplaceUploadSection = MarketplaceUploadSectionSingle | MarketplaceUploadSectionPostLink;

/**
 * One UI card per deliverable slot.
 * Carousel types use count for multi-file upload (submitted together).
 * Social-no-draft slots emit a postLink card instead of a file upload card.
 */
export function buildMarketplaceUploadSections(
  reqs: Record<string, MarketplaceOrderDeliverable>,
): MarketplaceUploadSection[] {
  const out: MarketplaceUploadSection[] = [];
  for (const r of Object.values(reqs)) {
    const isCarousel = deliverableIsCarousel(r.type);
    const baseTitle = deliverableLabel(r.type);
    const subtitle = marketplaceOrderRequirementUploadSubtitle(r);

    // Social-no-draft: creator submits a live post URL, not files
    if (deliverableRequiresPublishedPost(r.type) && !r.requiresDraftApproval) {
      out.push({
        kind: 'postLink',
        sectionId: `postLink:${r.id}`,
        requirementId: r.id,
        slotKey: r.id,
        title: baseTitle,
        subtitle,
      });
      continue;
    }

    if (isCarousel) {
      // Carousel: single section for multi-file upload together
      out.push({
        kind: 'single',
        sectionId: r.id,
        requirementId: r.id,
        slotKey: r.id,
        slotIndex: 0,
        title: baseTitle,
        subtitle,
      });
    } else {
      out.push({
        kind: 'single',
        sectionId: r.id,
        requirementId: r.id,
        slotKey: r.id,
        slotIndex: 0,
        title: baseTitle,
        subtitle,
      });
    }
  }
  return out;
}

export function marketplaceUploadTotalSlots(sections: MarketplaceUploadSection[]): number {
  return sections.length;
}
